import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as asset from '../asset'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: asset.RESOURCE.payload.dimension.partialId,
      partialId: asset.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'When was the asset acquired?',
    isOptional: true,
    name: 'Acquisition Date',
    partialId: PartialId.Standard.create('acq_date'),
    type: core.common.value.types.Intrinsic.Date,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
